import Car from "@/assets/icons/Car";
import AppButton from "@/components/shared/AppButton";
import VehicleCard from "@/components/shared/InfoCard/VehicleCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { T, useT } from "@transifex/react";
import { useRouter } from "expo-router";
import type { SavedPlate } from "ipctg-inflow-types/InFlowDB";

interface VehicleListProps {
  vehicles: SavedPlate[];
  isLoading: boolean;
}

const VehicleList = ({ vehicles, isLoading }: VehicleListProps) => {
  const router = useRouter();
  const t = useT();

  const renderList = () =>
    vehicles.map((item) => (
      <VehicleCard
        key={item.plate + item.nickname}
        plate={item.plate}
        nickname={item.nickname}
        onPress={() =>
          router.push({
            pathname: "/my-vehicles/edit-plate",
            params: {
              plate: item.plate,
              state: item.state,
              nickname: item.nickname,
            },
          })
        }
        isLoading={isLoading}
      />
    ));

  return (
    <VStack className="gap-[20px]">
      {renderList()}
      {isLoading ? (
        <>
          <Skeleton className="h-[48px] w-[200px] mx-auto mt-4 rounded-lg" />
          <Skeleton className="h-[20px] w-[250px] mx-auto mt-2" />
        </>
      ) : (
        <>
          <AppButton icon={Car} onPress={() => router.push("/my-vehicles/new-plate")} variant="outline" title={t("Add new vehicle")} />
          <Text className="font-[400] leading-[20px] opacity-50 text-[14px] text-center text-typography-900">
            <T _str="Activation of a parking session will only apply to the selected vehicle at time of purchase or redemption" />
          </Text>
        </>
      )}
    </VStack>
  );
};
export default VehicleList;
